import React, { useEffect, useState } from 'react';
import useSWR from 'swr';

import PoiCard from 'components/cards/poi/PoiCard';
import Poi from 'models/Poi';

function SuggestedPois({ poi }: { poi: Poi }) {
    const endpoint = '/public/pois/suggested';
    const [perPage, setPerPage] = useState(8);
    const params = {
        poi_id: poi.id.toString(),
        'page[size]': perPage.toString(),
        'page[number]': '1'
    };
    const query = `${new URLSearchParams(params).toString()}`;
    const { data: suggested } = useSWR(endpoint + '?' + query);

    const pois: Poi[] = suggested?.data;

    useEffect(() => {
        if (window.innerWidth > 1960) {
            setPerPage(10);
        }
    }, []);

    return (
        <>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3  xl:grid-cols-4 xl:gap-10 3xl:grid-cols-5 3xl:gap-14">
                {pois &&
                    pois.map((poi) => {
                        return (
                            poi.categories && (
                                <div className="justify-self-center w-full" key={poi.id}>
                                    <PoiCard
                                        prefetch={false}
                                        images={poi.thumbs}
                                        title={poi.name}
                                        link={`/ideja/${poi.slug}`}
                                        location={`${
                                            poi.areas.find((area) => area.type.key === 'municipality')?.name
                                        }, ${poi.areas.find((area) => area.type.key === 'region')?.name}`}
                                        poiType={poi.type}
                                        attributes={poi.attributes}
                                        category={poi.type?.default_category || poi.categories[0]}
                                    />
                                </div>
                            )
                        );
                    })}
            </div>
        </>
    );
}

export default SuggestedPois;
